import React, { useContext, useEffect, useState } from 'react';
import { PeopleTable } from 'common/people-table';
import { CollaboratorsContext } from 'context/collaborators-context';
import { VaultRow } from './components/vault-row';

// The people table does selecting, removing and inviting from a row itself
// (see common/people-table).
type VaultCollaboratorsProps = {
  vault: VaultCollaboratorsType;
  user: UserType;
  vaultSelection?: {
    id: number;
    selected: boolean | null;
    collaboratorsSelected: VaultCollaboratorType[];
  };
  onSelectVault: (vaultId: number) => void;
  /** Bumped by the page after an invite, to reload the open lists. */
  refreshKey?: number;
};

const VaultCollaborators: React.FC<VaultCollaboratorsProps> = ({
  vault,
  user,
  vaultSelection,
  onSelectVault,
  refreshKey = 0,
}) => {
  const {
    state: { queryParams },
  } = useContext(CollaboratorsContext);

  const isAnyCollaboratFilterApplied = Object.keys(queryParams).some(
    (param) =>
      [
        'collaboratorRole',
        'collaboratorStatus',
        'inviteOrigin',
        'contributors',
        'guests',
        'search',
        'collaboratorActivity',
      ].includes(param) &&
      !!queryParams[param as keyof CollaboratorsQueryParamsType],
  );

  const isFocused =
    !!queryParams.focusVaultId && queryParams.focusVaultId === vault.id;

  const [isOpened, setIsOpened] = useState(isFocused);

  useEffect(() => {
    setIsOpened(isAnyCollaboratFilterApplied || isFocused);
  }, [isAnyCollaboratFilterApplied, isFocused]);

  return (
    <>
      <VaultRow
        vault={vault}
        user={user}
        isOpened={isOpened}
        toggleIsOpened={() => setIsOpened((prev) => !prev)}
        isSelected={vaultSelection?.selected}
        handleSelectVault={() => onSelectVault(vault.id)}
      />
      {isOpened && (
        // Everyone the vault, its albums or memories are shared with: role,
        // what it applies to, status (see common/people-table).
        <PeopleTable
          vaultId={vault.id}
          vaultTitle={vault.title}
          refreshKey={refreshKey}
          limit={6}
        />
      )}
    </>
  );
};

export { VaultCollaborators };
